import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=602ac1fe&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602ac1fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('602ac1fe')) {
      api.createRecord('602ac1fe', component.options)
    } else {
      api.reload('602ac1fe', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=602ac1fe&scoped=true&", function () {
      api.rerender('602ac1fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/nouhin/detail.vue"
export default component.exports